<div class="product-card group" [class.product-card--sku]="variant === 'sku'" [class.product-card--item]="variant === 'item'" (click)="onCardClick()">
  <!-- Hover action buttons (top-right, item mode) -->
  <div *ngIf="variant === 'item' && showActions" class="product-card__actions" (click)="$event.stopPropagation()">
    <ng-container *ngIf="showEditAction">
      <app-edit-icon
        *appHasAccess="accessPermission"
        (click)="onEdit($event)"
        title="Edit">
      </app-edit-icon>
    </ng-container>

    <ng-container *ngIf="showDeleteAction">
      <app-delete-icon
        *appHasAccess="accessPermission"
        (click)="onDelete($event)"
        title="Delete">
      </app-delete-icon>
    </ng-container>
  </div>

  <!-- Image block -->
  <div class="product-card__image-wrap">
    <div class="product-card__image-box">
      <!-- Item variant image -->
      <ng-container *ngIf="variant === 'item'">
        <img *ngIf="item?.images?.length && item.images[0]?.document_url"
          [src]="item.images[0].document_url" [alt]="item?.title" class="product-card__img" />
      </ng-container>

      <!-- SKU variant image -->
      <ng-container *ngIf="variant === 'sku'">
        <ng-container *ngIf="item?.images && (item.images[0]?.document_url); else checkSkuStringImage">
          <img [src]="item.images[0].document_url" [alt]="item?.prod_sku_name || item?.title" class="product-card__img" />
        </ng-container>
        <ng-template #checkSkuStringImage>
          <ng-container *ngIf="item?.images; else checkParentProductImage">
            <img [src]="item.images" [alt]="item?.prod_sku_name || item?.title" class="product-card__img" />
          </ng-container>
        </ng-template>
        <ng-template #checkParentProductImage>
          <ng-container *ngIf="parentProductImages && (parentProductImages[0]?.document_url)">
            <img [src]="parentProductImages[0].document_url" [alt]="item?.prod_sku_name || item?.title" class="product-card__img" />
          </ng-container>
        </ng-template>
      </ng-container>
    </div>
    <span *ngIf="item?.qty === 0 || item?.prod_qty === 0" class="product-card__oos-badge">Out of Stock</span>
  </div>

  <!-- Body -->
  <div class="product-card__body">
    <!-- Top row: breadcrumb + kebab spacer -->
    <div class="product-card__top-row" [class.justify-content-end]="variant === 'sku'">
      <div *ngIf="variant === 'item'" class="product-card__breadcrumb">
        <span class="product-card__breadcrumb-item">{{ item?.prod_category || 'Uncategorized' }}</span>
        <span class="product-card__breadcrumb-sep">/</span>
        <span class="product-card__breadcrumb-item product-card__breadcrumb-item--active">
          {{ item?.prod_sub_category || 'GENERAL' }}
        </span>
      </div>

      <!-- Kebab spacer (hidden to preserve exact height) -->
      <button class="product-card__kebab" style="visibility: hidden; pointer-events: none;" (click)="$event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="19" cy="12" r="1"></circle>
          <circle cx="5" cy="12" r="1"></circle>
        </svg>
      </button>
    </div>

    <!-- Title -->
    <h2 class="product-card__title" [class.product-card__title--sku]="variant === 'sku'">{{ variant === 'sku' ? (item?.prod_sku_name || item?.title) : item?.title }}</h2>

    <!-- Code (Item variant only) -->
    <p *ngIf="variant === 'item'" class="product-card__code">Code: {{ item?.prod_code || 'N/A' }}</p>

    <!-- Tags (Item variant only) -->
    <div *ngIf="variant === 'item'" class="product-card__tags">
      <div class="product-card__tag product-card__tag--brand">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
          class="product-card__tag-icon">
          <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"></path>
          <path d="M12 22V12"></path>
          <polyline points="3.29 7 12 12 20.71 7"></polyline>
          <path d="m7.5 4.27 9 5.15"></path>
        </svg>
        <span class="product-card__tag-label--bold">
          {{ (item?.prod_brand && item?.prod_brand !== '[]' && item?.prod_brand?.length > 0) ? (item.prod_brand.join ? item.prod_brand.join(', ') : item.prod_brand) : 'No Brand' }}
        </span>
      </div>

      <div class="product-card__tag product-card__tag--type">
        <span class="product-card__tag-key">TYPE:</span>
        <span class="product-card__tag-val">{{ item?.type || item?.prod_type || 'Product' }}</span>
      </div>

      <div class="product-card__tag product-card__tag--grade">
        <span class="product-card__tag-key">GRADE:</span>
        <span class="product-card__tag-val">{{ item?.grade || item?.prod_grade || 'Regular' }}</span>
      </div>

      <ng-container *ngIf="item?.sku_parameter?.length > 0">
        <div class="product-card__tag product-card__tag--param" *ngFor="let sku of item.sku_parameter">
          <span class="product-card__tag-key">{{ sku?.parameter | uppercase }}:</span>
          <span class="product-card__tag-val" [title]="sku?.names?.join ? sku.names.join(', ') : sku?.names">
            {{ sku?.names?.join ? sku.names.join(', ') : sku?.names }}
          </span>
        </div>
      </ng-container>
    </div>

    <!-- Stats grid -->
    <div class="product-card__stats">
      <div class="product-card__stat">
        <p class="product-card__stat-label">Purchase</p>
        <p class="product-card__stat-value">{{ item?.prod_purchase_price | divide : '0.00' }}</p>
      </div>
      <div class="product-card__stat">
        <p class="product-card__stat-label">Sales</p>
        <p class="product-card__stat-value">{{ item?.prod_retail_price | divide : '0.00' }}</p>
      </div>
      <div class="product-card__stat">
        <p class="product-card__stat-label">Stock</p>
        <p class="product-card__stat-value">
          {{ item?.stock || item?.qty || 0 }}
          <span class="product-card__stat-unit">{{ item?.uom || 'unit' }}</span>
        </p>
      </div>
      <div class="product-card__stat product-card__stat--right">
        <p class="product-card__stat-label">Margin</p>
        <p class="product-card__stat-value product-card__stat-value--green" *ngIf="item?.percent; else emptyMargin">
          {{ item?.percent }}%
        </p>
        <ng-template #emptyMargin>
          <p class="product-card__stat-value product-card__stat-value--empty">-</p>
        </ng-template>
      </div>
    </div>

    <!-- Margin sub-label -->
    <div class="product-card__margin-sub" *ngIf="item?.percent">
      <span class="product-card__margin-sub-text">Margin %: {{ item?.percent }}%</span>
    </div>
  </div>
</div>
